<template>
  <div>
    <div class="p-fluid p-formgrid p-grid"> 
        <div class="p-field p-col-12 p-md-8">
            <label>Nome</label>
            <InputText v-model.trim="beneficio.nome" autocomplete="off" maxlength="100" v-on:keyup.enter="incluirBeneficio"/>                         
        </div>
        <div class="p-field p-col-auto">
            <Button :label="tituloBotaoIncluirBeneficio" class="p-ml-2" style="margin-top: 26px;" icon="pi pi-plus" 
                @click="incluirBeneficio"/>
        </div>
        <div class="p-field p-col-auto p-pl-3">
            <Button label="Novo" class="p-button-success" style="margin-top: 26px;" icon="pi pi-plus" @click="criarNovoBeneficio" v-if="benficioSelecionado"/>
        </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-8">
            <Listbox v-model="benficioSelecionado" :options="plano.beneficios" optionLabel="nome" listStyle="max-height:250px" @change="selecionarBeneficio">
                <template #option="slotProps">
                    {{slotProps.option.nome}} 
                    <i class="pi pi-check" v-if="slotProps.option.selecionado"></i>
                    <i class="pi pi-times" v-if="!slotProps.option.selecionado"></i>
                </template>
            </Listbox>
        </div>                    
        <div class="p-field p-col-1">
            <Button class="p-button-danger" icon="pi pi-times" title="Excluir" v-if="benficioSelecionado" @click="excluirBeneficio"/>  
        </div>                    
    </div>     
    <small class="p-invalid" v-if="!plano.beneficios.length">Informe os benefícios</small>
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field-checkbox p-ml-2" v-if="benficioSelecionado">                        
            <Checkbox v-model="benficioSelecionado.selecionado" :binary="true"/>     
            <label>Selecionado</label>                   
        </div> 
    </div>
  </div>
</template>

<script>

import BeneficioPlano from '@/model/BeneficioPlano';

export default {
    props: {
        plano: {
            type: Object,
            require: true,
        }
    },
    data() {
		return { 			
            benficioSelecionado: null,          
            beneficio: new BeneficioPlano(),         
            tituloBotaoIncluirBeneficio: 'Incluir',
		}
	},
    methods: {  
        incluirBeneficio() {           
            if(this.beneficio.nome != '') {
                let encontrou = false;
                this.plano.beneficios.forEach(bene => {
                    if(bene.nome.toLowerCase() == this.beneficio.nome.toLowerCase()) {
                        encontrou = true;
                    }
                });
                if(!encontrou) {
                    this.plano.beneficios.push(this.beneficio);
                }
                this.beneficio = new BeneficioPlano();              
                this.benficioSelecionado = null;
                this.tituloBotaoIncluirBeneficio = 'Incluir';
            }
        },
        selecionarBeneficio() {
            if(this.benficioSelecionado != null) {
                this.tituloBotaoIncluirBeneficio = 'Editar';              
                this.beneficio = this.benficioSelecionado;
            } else {
                this.tituloBotaoIncluirBeneficio = 'Incluir';
                this.beneficio = new BeneficioPlano();
            }
        },
        excluirBeneficio() {            
            let index = 0;
            this.plano.beneficios.forEach((bene, i) => {
                if(bene.nome.toLowerCase() == this.benficioSelecionado.nome.toLowerCase()) {                   
                    index = i;
                }
            });
            this.plano.beneficios.splice(index, 1);
            this.benficioSelecionado = null;
            this.beneficio = new BeneficioPlano();
        },
        criarNovoBeneficio() {
            this.benficioSelecionado = null;
            this.beneficio = new BeneficioPlano();
            this.tituloBotaoIncluirBeneficio = 'Incluir';
        },
    },
}
</script>

<style>

</style>